export default {
  SET_ACTIONS: 'setActions',
  SET_SELECTED_ACTION: 'setSelectedAction',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_TENANT_PERMISSIONS: 'setTenantPermissions',
}
